<template>
    <MapBasic :circles="circles" :loading-data="loading" :markers="markerList" :polygons="polygons"
              :refreshCenterCount="refreshCenterCount" :disable-back-navigation="filterOpen" show-search/>
</template>

<script>
import MapBasic from "@/components/MapBasic/MapBasic";

export default {
  name: "ZoneMap",
  components: {MapBasic},
  props: {
    zoneIds: {
      type: Array,
      required: true,
    },
    filterOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      zones: [],
      monitoredUsers: [],
      locations: [],
      loading: false,
      refreshCenterCount: 0,
    };
  },
  mounted() {
    if (this.organizationId) {
      this.getZones();
      this.getMonitoredUsers();
      this.getLocations();
    }
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    filterZones() {
      return this.zones.filter(zone => this.zoneIds.includes(zone.ZoneID));
    },
    circles() {
      return this.filterZones.filter(zone => zone.Shape === 'Circle').map(zone => ({
        lat: zone.Points[0].Latitude,
        lng: zone.Points[0].Longitude,
        radius: zone.Radius,
        type: zone.Type,
        id: zone.ZoneID,
        title: zone.Name,
      }));
    },
    polygons() {
      return this.filterZones.filter(zone => zone.Shape === 'Polygon').map(zone => ({
        points: zone.Points.map(point => ({
          lat: point.Latitude,
          lng: point.Longitude,
        })),
        type: zone.Type,
        id: zone.ZoneID,
        title: zone.Name,
      }));
    },
    monitoredUserIds() {
      return new Set(this.monitoredUsers
          .filter(user => this.zoneIds.includes(user.ZoneID))
          .map(user => user.UserID));
    },
    markerList() {
      return this.locations
          .filter(location => this.monitoredUserIds.has(location.UserID)
              && location.Location && location.Location.Position)
          .map(location => ({
            ...location.Location,
            lat: location.Location.Position.Latitude,
            lng: location.Location.Position.Longitude,
          }));
    },
  },
  watch: {
    organizationId() {
      this.getZones();
      this.getMonitoredUsers();
      this.getLocations();
    },
    zoneIds() {
      this.refreshCenterCount++;
    }
  },
  methods: {
    getZones() {
      this.loading = true;
      const url = this.$store.getters.zones;
      this.axios.get(url).then(({data}) => {
        this.zones = data.Result;
        this.refreshCenterCount++;
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
    },
    getMonitoredUsers() {
      const url = this.$store.getters.zonesMonitoredUsers;
      this.axios.get(url).then(({data}) => {
        this.monitoredUsers = data.Result;
        this.refreshCenterCount++;
      });
    },
    getLocations() {
      const url = this.$store.getters.organizationLocations;
      this.axios.get(url).then(({data}) => {
        this.locations = data.Result;
        this.refreshCenterCount++;
      });
    }
  }
};
</script>

<style scoped>

</style>
